import { createIdentitiesFetcher } from '../contexts/Fetcher';
import { apiUser } from '../resources/api/apiUser';
import { useContext } from 'react';
import { AuthContext } from '../contexts/AuthContext';

const { useGetMfaDevices } = apiUser;

export const MFADevicesFetcher = createIdentitiesFetcher(() => {
  const { identity } = useContext(AuthContext);
  return useGetMfaDevices(identity?.userId).execute;
});
